import { createAction } from 'redux-actions';
export var SET_NEXT_STEP = 'SET_NEXT_STEP';
export var SET_PREV_STEP = 'SET_PREV_STEP';
export var SET_STEP = 'SET_STEP';
export var setNextStep = createAction(SET_NEXT_STEP, function () { });
export var setStep = createAction(SET_STEP, function (stepType) { return stepType; });
